export default (properties) => {
  return ({ item }) => {
    return {
      item,
      ...properties
    }
  }
}
